export default [
  {
    title: 'Dashboard',
    icon: 'HomeIcon',
    route: 'cop-dashboard',
  },
  // {
  //   title: 'Dashboards',
  //   icon: 'LayoutIcon',
  //   route: 'dashboard-ecommerce',
  // },
 
]
